import { Typography } from '@scaleaq/scaleui';
import styled, { css } from 'styled-components';

import { colors, responsive } from '@/utils';

export const SiteCardRoot = styled.button<{ $selected?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  min-width: 0;
  min-height: 6rem;
  margin: 0;
  padding: ${responsive.spacing['2xlarge']};
  text-align: left;
  cursor: pointer;
  color: inherit;
  border-radius: ${responsive.spacing.xlarge};
  border: 1px solid
    ${props => (props.$selected ? colors.stroke.action.solid[100] : colors.stroke.neutral[50])};
  background: ${colors.surface.cards};
  transition:
    background 120ms ease,
    border-color 120ms ease;

  &:hover,
  &:focus-visible {
    border-color: ${colors.stroke.action.solid[100]};
    background: ${colors.background.action.soft[100]};
  }

  &:focus-visible {
    outline: 2px solid ${colors.stroke.focused};
    outline-offset: 2px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
  }

  ${props =>
    props.$selected &&
    css`
      background: ${colors.background.action.soft[100]};
    `}
`;

/* Site names read as labels on the card, so they are set in capitals. */
export const SiteCardName = styled(Typography)`
  text-transform: uppercase;
  overflow-wrap: anywhere;
`;
